<template>
  <div style="padding:10px">
    <v-layout row wrap>
      <v-flex xs6 sm6>
        <Select
          label="Ano Letivo"
          :options="optionsAno"
          v-model.number="aaletivo"
          :disabled="loadings"
          :v="$v.aaletivo"
          @change="carregaEscolas()"
        />
      </v-flex>
    </v-layout>
    <div class="bloco-btn">
      <v-card>
        <v-col>
          <v-card-text>Consolidação de notas na tabela EIDALURE</v-card-text>
          <v-btn color="cyan" :disabled="loadings" :loading="loading['nota']" @click="nota()" class="rounded-sm font-weight-regular" >Notas</v-btn>
        </v-col>
      </v-card>
      <v-card>
        <v-col>
            <v-card-text>Consolidação de frequências por período e por dia nas tabelas EIDALURE e EIDFREQU</v-card-text>

            <div class="containerFrequencia">
            <Select style="width: 300px" :label="`Escola`" :options="optionsEscola" v-model="cdescola"  @change="changeEscola" />
            <Select style="width: 300px" :label="`Período Avaliativo`" :options="optionsPeriodo" v-model="cdpravadi" :disabled="loadingPeriodoAvaliativo || optionsPeriodo.length <= 0" />
            <v-btn
              color="cyan"
              :disabled="loadings"
              :loading="loading['frequencia']"
              @click="frequencia()"
              class="rounded-sm font-weight-regular"
            >Frequências</v-btn>
            </div>
        </v-col>
      </v-card>
      <v-card>
        <v-col>
          <v-card-text>Consolidação de conceitos na tabela EIDALURE</v-card-text>
          <v-btn
            color="cyan"
            :disabled="loadings"
            :loading="loading['conceito']"
            @click="conceito()"
            class="rounded-sm font-weight-regular"
          >Conceitos</v-btn>

        </v-col>
      </v-card>
      <v-card>
        <v-col>
          <v-card-text>Consolidação de parecer descritivo na tabela EIDAVDES</v-card-text>
          <v-btn
            color="cyan"
            :disabled="loadings"
            :loading="loading['parecer']"
            @click="parecer()"
            class="rounded-sm font-weight-regular"
          >Pareceres Descritivos</v-btn>

        </v-col>
      </v-card>
    </div>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const SincronizacaoEiRepository = RepositoryFactory.get("sincronizacaoEi");
const EscolaRepository = RepositoryFactory.get('escola');
const PeriodoAvaliativoRepository = RepositoryFactory.get('periodoAvaliativo');


const defaultSelect = () => ({
  text: "",
  value: ""
});
export default {
  name: "SincronizarEi",
  data() {
    return {
      aaletivo: null,
      cdescola: null,
      cdpravadi: null,
      anoAtual: null,
      submitText: "",
      snackbar: false,
      loadingPeriodoAvaliativo: false,
      loading: {
        nota: false,
        frequencia: false,
        conceito: false,
        parecer: false
      },
      optionsPeriodo: [],
      optionsEscola: []

    };
  },
  validations() {
    return {
      aaletivo: { required }
    };
  },
  async created() {
    this.aaletivo = this.getAnoAtualServidor;

    this.carregaEscolas();

    this.$Progress.finish();
  },
  methods: {
    async nota() {
      try {
        this.snackbar = false;
        this.loading.nota = true;
        const { data } = await SincronizacaoEiRepository.postNota({
          aaletivo: this.aaletivo
        });
        this.submitText = data.results.msg;
        this.snackbar = true;
      } finally {
        this.loading.nota = false;
      }
    },
    async frequencia() {
      try {
        this.snackbar = false;
        this.loading.frequencia = true;


        const filtros = {
          aaletivo: this.aaletivo,
          cdescola: this.cdescola || 0,
          cdpravadi: this.cdpravadi || 0,
        }

        // console.log(filtros);

        // return;

        const { data } = await SincronizacaoEiRepository.postFrequencia(filtros);
        this.submitText = data.results.msg;
        this.snackbar = true;
      } finally {
        this.loading.frequencia = false;
      }
    },
    async conceito() {
      try {
        this.snackbar = false;
        this.loading.conceito = true;
        const { data } = await SincronizacaoEiRepository.postConceito({
          aaletivo: this.aaletivo
        });
        this.submitText = data.results.msg;
        this.snackbar = true;
      } finally {
        this.loading.conceito = false;
      }
    },
    async parecer() {
      try {
        this.snackbar = false;
        this.loading.parecer = true;
        const { data } = await SincronizacaoEiRepository.postParecerDescritivo({
          aaletivo: this.aaletivo
        });
        this.submitText = data.results.msg;
        this.snackbar = true;
      } finally {
        this.loading.parecer = false;
      }
    },
    async carregaEscolas() {
      const { data } = await EscolaRepository.getTodasEscolas(this.aaletivo);

      this.escolas = data.results;
      this.optionsEscola = data.results.map(escola => ({
        value: escola.cdescola,
        text: escola.nmescola,
        cdtipesc: escola.cdtipesc
      }))

      this.optionsEscola.unshift({value: null, text: ''});
    },
    async changeEscola() {
      this.optionsPeriodo = [];
      //console.log('Escola selecionada', this.cdescola)
      if(!this.cdescola) {
        return;
      }

      try {
        this.loadingPeriodoAvaliativo = true;
        const escolas = JSON.parse(JSON.stringify(this.optionsEscola));
        const escola = this.escolas.find(item => item.cdescola == this.cdescola);
        const cdtipesc = escola.cdtipesc;

        const { data } = await PeriodoAvaliativoRepository.getPeriodoAvaliativoPorEscola(
        {
          aaletivo: this.aaletivo,
          cdescola: this.cdescola,
          cdtipesc,
        }
        );

        this.optionsPeriodo = data.results.map(periodo => ({
          value: periodo.cdpravadi,
          text: periodo.dspravadi
        }))

        this.optionsPeriodo.unshift({value: null, text: ''});

      } finally {

        this.loadingPeriodoAvaliativo = false;
      }


    }
  },
  computed: {
    ...mapGetters(["getAnoAtualServidor", "getAnoInicioSistema"]),
    optionsAno() {
      if (!this.getAnoInicioSistema || !this.getAnoAtualServidor) {
        return [];
      }
      let retornoOptions = [defaultSelect()];
      for (
        let i = this.getAnoAtualServidor;
        i >= this.getAnoInicioSistema;
        i--
      ) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
    loadings() {
      if (
        this.loading.nota == true ||
        this.loading.frequencia == true ||
        this.loading.conceito == true ||
        this.loading.parecer == true
      )
        return true;
      else return false;
    }
  }
};
</script>
<style lang="scss">
.bloco-btn {
  .v-btn__content {
    color: white;
  }
  .v-card {
    margin: 20px 0px;
    text-align: right;
    .v-card__text {
      text-align: left;
    }
  }
  .icon {
    margin: 0 !important;
    padding: 10px;
    i {
      color: black !important;
    }
  }
}


.containerFrequencia {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 16px;
}

</style>
